import React from "react"
import styled from "styled-components"

const ListItem = styled.li`
  padding: 0.25rem 0;
`

const TableOfContents = () => {
  return (
    <ol>
      <ListItem>Introduction</ListItem>
      <ListItem>Purpose and Overview</ListItem>
      <ListItem>Definitions and General Information</ListItem>
      <ListItem>User Rights and Obligations</ListItem>
      <ListItem>Employer Rights and Responsibilities</ListItem>
      <ListItem>Company Responsibilities</ListItem>
      <ListItem>Data Handling and User Consent</ListItem>
      <ListItem>Requests and Disputes</ListItem>
      <ListItem>Section 43 Compliance (ECTA)</ListItem>
      <ListItem>Legal Terms</ListItem>
      <ListItem>Contact Information</ListItem>
    </ol>
  )
}

export default TableOfContents
